import { useServicesQuery } from '@/services/api';
import type { ServicesApiGetEnvHealthQueryParams } from '@/services/api/services-api';
import { WORKSPACE_HEALTH_REFETCH_INTERVAL_ACTIVE } from '../constants';

export function useEnvHealthDelayHistory(
  workspaceId: number,
  simulate: ServicesApiGetEnvHealthQueryParams['simulate'],
) {
  return useServicesQuery(
    'getEnvHealthDelayHistory',
    { params: { environment_id: workspaceId }, query: { simulate } },
    {
      refetchInterval: WORKSPACE_HEALTH_REFETCH_INTERVAL_ACTIVE,
      enabled: workspaceId > 0,
      refetchOnMount: 'always',
      refetchOnWindowFocus: 'always',
    },
  );
}
